export default __webpack_public_path__ + "static/hcp-engage-background-635377b39250f6da8836e841dd8a1dfa.jpg";